export const getTextWidth = (text, font, family = "Inter") => {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    // context.font = "11px Arial";      
    context.font = `${font}pt ${family}`;
    const metrics = context.measureText(text);
    return Math.round(metrics.width);
  };
